// Maps a dashboard path to a stable compartment key (the first segment under
// /dashboard/), and provides friendly labels for the admin UI.

export function compartmentForPath(pathname) {
  if (!pathname) return null;
  const parts = pathname.split('?')[0].split('/').filter(Boolean);
  const dashIdx = parts.indexOf('dashboard');
  if (dashIdx === -1) return null;
  const seg = parts[dashIdx + 1];
  if (!seg) return 'overview'; // /dashboard itself
  const key = seg.toLowerCase().replace(/[^a-z0-9-]/g, '');
  return key || null;
}

export const COMPARTMENT_LABELS = {
  overview: 'Overview',
  'unified-chat': 'Ask JPRO',
  chats: 'Chat History',
  projects: 'Projects',
  notes: 'Notes',
  tasks: 'Tasks',
  'request-services': 'Service Requests',
  'service-requests': 'Service Requests',
  leaderboards: 'Leaderboards',
  news: 'News',
  ait: 'AIT',
  'audit-tracker': 'Audit Tracker',
  'data-extraction': 'Data Extraction',
  imagen: 'Creative Studio',
  documents: 'Documents',
  training: 'Training Intelligence',
  'training-studio': 'Training Studio',
  prospec360: 'ProSpec360',
  'profitability-index': 'Profitability',
  email: 'Email',
  'team-chat': 'Team Chat',
  management: 'Management',
  'client-management': 'Client Management',
  'client-audit-tracker': 'Client Audit Tracker',
  admin: 'Admin',
  settings: 'Settings',
  upgrade: 'Upgrade',
};

export function compartmentLabel(key) {
  return COMPARTMENT_LABELS[key] || key;
}
